export const markNotificationRead = async (api, notificationId) => {
  const response = await api.post(`/api/notifications/${notificationId}/read`);
  if (response.data?.success !== false) return true;

  // A second tab may have marked this alert already. Confirm that state
  // before treating the non-mutating response as a failure.
  const current = await api.get('/api/notifications');
  const item = (current.data?.notifications || []).find(notification => notification.id === notificationId);
  return Boolean(item && (item.read || item.is_read));
};
